import { UserLoginMutationDocument as __graphqlDocument0 } from 'store/client/documents/UserLoginMutationDocument'; import { UserLogoutMutationDocument as __graphqlDocument1 } from 'store/client/documents/UserLogoutMutationDocument'; import { SsoLoginMutationDocument as __graphqlDocument2 } from 'store/client/documents/SsoLoginMutationDocument'; 

export const UserLoginMutation = __graphqlDocument0



;

export const UserLogoutMutation = __graphqlDocument1



;

export const SsoLoginMutation = __graphqlDocument2



;
